import { Select } from "@clintonelec/react-storybook";
import type { FourthStream, CodecSettingsState } from "Interfaces";
import {
	fourthStreamFrameRateOptions, fourthStreamResolutionOptions, useStreamSettingsOptions
} from "Data/Objects/CodecSettingsOptions";
import { type Dispatch, Fragment, memo, type SetStateAction } from "react";
import type { UseStreamSettings } from "Data/Objects/Camera";
import { produce } from "immer";

type FourthTabContentProps = {
	codecSettingsState: [ CodecSettingsState, Dispatch<SetStateAction<CodecSettingsState>> ];
	streamIndex: number;
};

function FourthTabContent(props: FourthTabContentProps) {
	const { codecSettingsState, streamIndex } = props;
	const [ localCodecSettings, setLocalCodecSettings ] = codecSettingsState;
	const { useStreamSettings, frameRateLabel, resolution } = localCodecSettings.streams[ streamIndex ] as FourthStream;

	const handleUseStreamSettingsSelect = (stream: string | null) => {
		const newState = produce(localCodecSettings, draft => {
			if (!stream) {
				return;
			}

			draft.streams[ streamIndex ].useStreamSettings = stream as UseStreamSettings;

			switch (stream) {
				case "mainStream": {
					const mainStream = draft.streams[ 0 ];

					draft.streams[ streamIndex ].frameRate = mainStream.frameRate * frameRateLabel;

					break;
				}

				case "secondStream": {
					const secondStream = draft.streams[ 1 ];

					draft.streams[ streamIndex ].frameRate = secondStream.frameRate * frameRateLabel;

					break;
				}
			}
		});

		setLocalCodecSettings(newState);
	};

	const handleFrameRateLabelSelect = (newFrameRateLabel: string | null) => {
		const newState = produce(localCodecSettings, draft => {
			if (!newFrameRateLabel) {
				return;
			}

			(draft.streams[ streamIndex ] as FourthStream).frameRateLabel = +newFrameRateLabel;

			switch (useStreamSettings) {
				case "mainStream": {
					const mainStream = draft.streams[ 0 ];

					draft.streams[ streamIndex ].frameRate = mainStream.frameRate * +newFrameRateLabel;

					break;
				}

				case "secondStream": {
					const secondStream = draft.streams[ 1 ];

					draft.streams[ streamIndex ].frameRate = secondStream.frameRate * +newFrameRateLabel;

					break;
				}
			}
		});

		setLocalCodecSettings(newState);
	};

	const handleResolutionSelect = (newResolution: string | null) => {
		setLocalCodecSettings(produce(localCodecSettings, draft => {
			if (!newResolution) {
				return;
			}

			draft.streams[ streamIndex ].resolution = newResolution;
		}));
	};

	return (
		<Fragment>
			<div className="form-row">
				<span>Use Stream Settings</span>
				<Select
					allowClear={ false }
					className="form-select"
					onSelect={ handleUseStreamSettingsSelect }
					options={ useStreamSettingsOptions }
					value={ useStreamSettings }
				/>
			</div>
			<div className="form-row">
				<span>Frame Rate</span>
				<Select
					allowClear={ false }
					className="form-select"
					onSelect={ handleFrameRateLabelSelect }
					options={ fourthStreamFrameRateOptions }
					value={ frameRateLabel }
				/>
			</div>
			<div className="form-row">
				<span>Resolution</span>
				<Select
					allowClear={ false }
					className="form-select"
					onSelect={ handleResolutionSelect }
					options={ fourthStreamResolutionOptions }
					value={ resolution }
				/>
			</div>
		</Fragment>
	);
}

export default memo(FourthTabContent);
